import { render, staticRenderFns } from "./PlayerProfileCard.vue?vue&type=template&id=3214df81&"
import script from "./PlayerProfileCard.vue?vue&type=script&lang=js&"
export * from "./PlayerProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerProfileCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports